import React from 'react';

import { C, CT, soft } from '../../constants/theme';
import { useTranslation } from '../../i18n/I18nProvider.jsx';

// The follow-up chips under the latest answer. core.md §9.1.
//
// `followUpSuggestions` comes back with the answer; each chip SENDS that
// question when pressed, and spends the same ten پارسه as one the student
// typed. So they are chips, not buttons on the composer: something one reaches
// for deliberately, not something one presses on the way to somewhere else.
//
// They belong to the LATEST answer only. Chips left under an old answer would
// re-ask a question the conversation has already moved past.

export default function FollowUps({ items, onPick, disabled = false }) {
  const { t } = useTranslation();
  const chips = (items || []).filter((s) => String(s || '').trim());
  if (!chips.length) return null;

  return (
    <div
      data-testid="chat-followups"
      style={{ padding: '8px 16px 0', display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}
    >
      <span style={{ fontSize: 11.5, color: CT.mute }}>{t('chat.followUps')}</span>
      {chips.map((text, i) => (
        <button
          key={`${i}-${text}`}
          type="button"
          disabled={disabled}
          onClick={() => onPick?.(text)}
          data-testid="followup-chip"
          style={{
            font: 'inherit', fontSize: 12.5, cursor: disabled ? 'default' : 'pointer',
            padding: '6px 12px', borderRadius: 999,
            border: `1px solid ${soft(C.teal, 0.4)}`,
            background: soft(C.teal, 0.1),
            color: CT.accentInk,
            opacity: disabled ? 0.6 : 1,
          }}
        >
          {text}
        </button>
      ))}
    </div>
  );
}
